import { type FC } from "react";

import { PriceField } from "~/components/tableField";
import { RichTooltip } from "~/components/UI/RichTooltip";
import type { IOutcomeConsensus } from "~/types/event";

import * as Styles from "../styles";
import { getPriceBreakdown } from "./getPriceBreakdown";

const tooltipTitle = "Price Breakdown";
const tooltipActionText = "Learn more about our methodology";

interface IPriceGroupedCellProps {
  outcome: IOutcomeConsensus | null;
}

export const PriceGroupedCell: FC<IPriceGroupedCellProps> = ({ outcome }) => {
  const chance = outcome?.chance ?? null;

  return (
    <PriceField
      price={chance ?? 0}
      priceNo={null}
      NA={chance === null}
      withText={true}
      padding="0.6rem 0.35rem 0.6rem 0"
      textSx={{ fontWeight: 700 }}
    >
      <RichTooltip
        textTitle={tooltipTitle}
        title={getPriceBreakdown(outcome)}
        actionText={tooltipActionText}
      >
        <Styles.Icon
          color="disabled"
          fontSize="small"
          sx={{ fontSize: "14px" }}
        />
      </RichTooltip>
    </PriceField>
  );
};
